import type { PlainText as PlainTextType } from 'types/capi/content';
import { PlainTextStyle } from 'types/capi/content';

type Props = {
  item: PlainTextType;
};

function getTextStyleClassName(style: PlainTextStyle | undefined) {
  if (style === PlainTextStyle.BOLD) return 'font-bold';
  if (style === PlainTextStyle.ITALICS) return 'italic';
  if (style === PlainTextStyle.BOLD_ITALICS) return 'font-bold italic';
}

const PlainText = ({ item }: Props) => {
  return <span className={getTextStyleClassName(item.style)}>{item.text}</span>;
};

export default PlainText;
